import { connect } from 'react-redux';
import CardsListMobile from './index';
import { mapStateToProps, mapDispatchToProps } from './index.props';

export default connect(mapStateToProps, mapDispatchToProps)(CardsListMobile);
